import html from './Login.html';
import { login } from '../../api/embyApi';
import { boot } from '../../app';

export function renderLogin(root: HTMLElement): void {
  root.innerHTML = html;

  const form = root.querySelector('#loginForm') as HTMLFormElement;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const errorEl = form.querySelector('#error') as HTMLElement;
    errorEl.textContent = '';
    const username = (form.querySelector('#username') as HTMLInputElement).value;
    const password = (form.querySelector('#password') as HTMLInputElement).value;
    try {
      await login(username, password);
      await boot(); // no shell/router running yet at the login screen - (re)boot into it now
    } catch {
      errorEl.textContent = "Connexion impossible - vérifie ton nom d'utilisateur et ton mot de passe.";
    }
  });
}
